<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <validation-observer ref="form" tag="div">
      <div class="text-center mb-3">
        <img :src="SuccessIcon" alt="" class="d-block mx-auto mb-3" height="40" width="40">
        <h4>{{ approveConfirmTitle }}</h4>
        <p class="m-0" v-html="approveConfirmDescription"></p>
      </div>
      <b-form-group
          :label="lodash.startCase($t('balancing_approvals.modal_messages.approve_reason_label'))"
          class="mt-3"
          label-for="balancing-approval-approve-reason"
      >
        <b-form-textarea
            id="balancing-approval-approve-reason"
            v-model="form.description"
            :placeholder="$t('balancing_approvals.modal_messages.approve_reason_placeholder')"
            rows="4"
        />
      </b-form-group>
    </validation-observer>
    <template #modal-footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <b-button
            block
            variant="light"
            @click="handleCancel"
        >
          <b>{{ lodash.startCase($t('balancing_approvals.buttons.cancel')) }}</b>
        </b-button>
        <b-button
            block
            class="m-0"
            variant="primary"
            @click="handleConfirm"
        >
          <b>{{ lodash.startCase($t('balancing_approvals.buttons.yes_confirm')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import SuccessIcon from '@/assets/icons/SuccessIcon.svg'

export default {
  name: 'balancing-approval-approve-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'balancing-approval-approve-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      SuccessIcon,
      options: {
        message: null,
        modelId: null,
      },
      form: {
        description: '',
      },
      resolvePromise: null,
    };
  },
  computed: {
    approveConfirmTitle() {
      return this.options.title || `${this.$t('balancing_approvals.modal_messages.confirm_approve_title')}?`
    },
    approveConfirmDescription() {
      if (this.options.message) {
        return this.options.message
      }

      const description = this.$t('balancing_approvals.modal_messages.{something}_confirm_approve_description')
      const safeSomething = this.lodash.escape(this.options.modelId || '')

      return description.replace('{something}', `<strong>${safeSomething}</strong>`)
    }
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          message: null,
          modelId: null,
          ...options,
        }
        this.form.description = ''
        this.$bvModal.show(this.id)

        this.resolvePromise = resolve

        this.$nextTick(() => {
          this.$refs.form?.reset()
        })
      });
    },
    async handleConfirm() {
      if (!this.$refs.form) {
        return
      }

      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      if (this.resolvePromise) {
        this.resolvePromise({
          description: this.form.description.trim(),
        })
      }
      this.hide()
    },
    handleCancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
